import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../service/common';
import { concat } from 'lodash';

const ITEM_PERPAGE = 10;
interface AdminUserState {
    adminUser: any,
    loadingAdminUser: Boolean
    // totalCount: Number
}

let initialState: AdminUserState = {
    adminUser: null,
    loadingAdminUser: false
}

const login: any = createAsyncThunk(
    'login',
    async (data, { rejectWithValue }) => { 
        try {
            let requestApiUrl = `/admin/login`;
            const response: any = await request('post', requestApiUrl,data);
            return { data: response.data.data};
        } catch (err) {
           
            return rejectWithValue(err.response.data)
        }
    }
);


const getProjectById: any = createAsyncThunk(
    'getProjectById',
    async (id, { rejectWithValue }) => {
        try {
            let requestApiUrl = '/project/project/' + id;
            const response: any = await request('get', requestApiUrl);
            return { data: response.data.data};
        } catch (err) {
            console.log("err", err)
            return rejectWithValue(err)
        }
    }
);
const slice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        logout: (state) => {
            localStorage.removeItem("token");
            state.adminUser=null
        },
    },
    extraReducers: {
        // Add reducers for additional action types here, and handle loadingNotice state as needed
        [login.fulfilled]: (state, action) => {
            console.log('fulfilled');
            const { data } = action.payload;
            // console.log(data.super_admin)
            localStorage.setItem("token", data.token)
            state.adminUser = data.super_admin;
        },
        [login.pending]: (state, action) => {
        },
        [login.rejected]: (state, action) => {
        },
        // [getProjectById.fulfilled]: (state, action) => {
        //     const { data } = action.payload;
        //     state.selectedProject = data
        //     state.loadingProject = false;
        // },
        // [getProjectById.pending]: (state, action) => {
        //     state.selectedProject = {}
        //     state.loadingProject = true;
        // },
        // [getProjectById.rejected]: (state, action) => {
        //     state.loadingProject = false;

        // }

    }
})




export const { logout} = slice.actions;
export { login };
export default slice.reducer;